<template>
  <el-drawer
    custom-class="user_info_modal"
    v-model="modelMainVisible"
    @open="openModal"
    @close="closeModal"
    :direction="'btt'"
    :destroy-on-close="true"
    :append-to-body="true"
  >
    <!-- <el-button class="button_more" type="transparent" icon="el-icon-more" @click="bottomDropUp = true"></el-button> -->

    <el-carousel
      :class="user.files && user.files.length ? 'with_arrow' : ''"
      trigger="click"
      :autoplay="false"
    >
      <el-carousel-item>
        <img class="user_image" :src="user.image" v-if="user.image" />
        <el-empty
          class="user_image"
          :image="require(`@/assets/img/job-seeker/profile.svg`)"
          v-else
        >
        </el-empty>
      </el-carousel-item>
      <el-carousel-item
        :class="$filters.getFileType(file)"
        v-for="(file, i) in user.files"
        :key="file.src"
      >
        <img
          class="user_image"
          :src="file.url"
          alt=""
          v-if="$filters.getFileType(file) == 'image'"
        />
        <video-js
          :options="videoPlayerOptions"
          :sources="videosSrc[i]"
          v-if="$filters.getFileType(file) == 'video'"
        />
      </el-carousel-item>
    </el-carousel>

    <div class="user_image_gradient"></div>

    <div class="user_main_info">
      <h3 class="user_name">
        {{ user.applicantName }}
      </h3>
      <p class="user_address">
        {{ user.address }}
      </p>
    </div>

    <div class="separator"></div>

    <div class="preview-section">
      <div class="preview-section__header">
        <div class="preview-section__title">Basic Details</div>
      </div>

      <div class="preview-section__body">
        <div class="icon-row">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.66685 18.3333H13.3335C16.6835 18.3333 17.2835 16.9917 17.4585 15.3583L18.0835 8.69167C18.3085 6.65833 17.7252 5 14.1668 5H5.83351C2.27518 5 1.69185 6.65833 1.91685 8.69167L2.54185 15.3583C2.71685 16.9917 3.31685 18.3333 6.66685 18.3333Z"
              stroke="rgb(var(--locumate-primary-color))"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M6.6665 5.00033V4.33366C6.6665 2.85866 6.6665 1.66699 9.33317 1.66699H10.6665C13.3332 1.66699 13.3332 2.85866 13.3332 4.33366V5.00033"
              stroke="rgb(var(--locumate-primary-color))"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.6668 10.8333V11.6667C11.6668 11.675 11.6668 11.675 11.6668 11.6833C11.6668 12.5917 11.6585 13.3333 10.0002 13.3333C8.35016 13.3333 8.3335 12.6 8.3335 11.6917V10.8333C8.3335 10 8.3335 10 9.16683 10H10.8335C11.6668 10 11.6668 10 11.6668 10.8333Z"
              stroke="rgb(var(--locumate-primary-color))"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M18.0415 9.16699C16.1165 10.567 13.9165 11.4003 11.6665 11.6837"
              stroke="rgb(var(--locumate-primary-color))"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M2.18311 9.3916C4.05811 10.6749 6.17477 11.4499 8.33311 11.6916"
              stroke="rgb(var(--locumate-primary-color))"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <span>Experience: {{ user.experience }}</span>
        </div>
        <div class="icon-row">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.22656 11.9412C7.22656 13.0162 8.05156 13.8829 9.07656 13.8829H11.1682C12.0599 13.8829 12.7849 13.1245 12.7849 12.1912C12.7849 11.1745 12.3432 10.8162 11.6849 10.5829L8.32656 9.41621C7.66823 9.18288 7.22656 8.82454 7.22656 7.80788C7.22656 6.87454 7.95156 6.11621 8.84323 6.11621H10.9349C11.9599 6.11621 12.7849 6.98288 12.7849 8.05788"
              stroke="rgb(var(--locumate-primary-color))"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M10 5V15"
              stroke="rgb(var(--locumate-primary-color))"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M9.99984 18.3337C14.6022 18.3337 18.3332 14.6027 18.3332 10.0003C18.3332 5.39795 14.6022 1.66699 9.99984 1.66699C5.39746 1.66699 1.6665 5.39795 1.6665 10.0003C1.6665 14.6027 5.39746 18.3337 9.99984 18.3337Z"
              stroke="rgb(var(--locumate-primary-color))"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span>Hourly Rate: {{ user.hourlyRate }}</span>
        </div>
        <div class="icon-row">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.22656 11.9412C7.22656 13.0162 8.05156 13.8829 9.07656 13.8829H11.1682C12.0599 13.8829 12.7849 13.1245 12.7849 12.1912C12.7849 11.1745 12.3432 10.8162 11.6849 10.5829L8.32656 9.41621C7.66823 9.18288 7.22656 8.82454 7.22656 7.80788C7.22656 6.87454 7.95156 6.11621 8.84323 6.11621H10.9349C11.9599 6.11621 12.7849 6.98288 12.7849 8.05788"
              stroke="rgb(var(--locumate-primary-color))"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M10 5V15"
              stroke="rgb(var(--locumate-primary-color))"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M9.99984 18.3337C14.6022 18.3337 18.3332 14.6027 18.3332 10.0003C18.3332 5.39795 14.6022 1.66699 9.99984 1.66699C5.39746 1.66699 1.6665 5.39795 1.6665 10.0003C1.6665 14.6027 5.39746 18.3337 9.99984 18.3337Z"
              stroke="rgb(var(--locumate-primary-color))"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span>Annual Rate: {{ user.annuallyRate }}</span>
        </div>
        <div class="icon-row" v-if="user.federalPharmacistSupport === 1 && isUS">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.29169 1.66663V18.3333" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
            stroke-linecap="round" stroke-linejoin="round" />
          <path
            d="M4.29169 3.33337H13.625C15.875 3.33337 16.375 4.58337 14.7917 6.16671L13.7917 7.16671C13.125 7.83337 13.125 8.91671 13.7917 9.50004L14.7917 10.5C16.375 12.0834 15.7917 13.3334 13.625 13.3334H4.29169"
            stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
          <span v-if="user.federalPharmacistSupport === 1">Federal Pharmacist</span>
        </div>
      </div>
    </div>

    <div class="separator"></div>
    <div class="preview-section">
      <div class="preview-section__header">
        <div class="preview-section__title">Resume</div>
      </div>

      <div class="preview-section__body">
        <div v-if="user.cv.url" class="applicant-cv">
          <div v-if="user.cv.fileExtension == 'pdf'">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21.0666 2.94633C20.5199 2.39967 19.5732 2.773 19.5732 3.533V8.18633C19.5732 10.133 21.2266 11.7463 23.2399 11.7463C24.5066 11.7597 26.2666 11.7597 27.7732 11.7597C28.5332 11.7597 28.9332 10.8663 28.3999 10.333C26.4799 8.39966 23.0399 4.91967 21.0666 2.94633Z"
                fill="rgb(var(--locumate-secondary-color))"
              />
              <path
                d="M27.3335 13.587H23.4802C20.3202 13.587 17.7468 11.0137 17.7468 7.85366V4.00033C17.7468 3.26699 17.1468 2.66699 16.4135 2.66699H10.7602C6.6535 2.66699 3.3335 5.33366 3.3335 10.0937V21.907C3.3335 26.667 6.6535 29.3337 10.7602 29.3337H21.2402C25.3468 29.3337 28.6668 26.667 28.6668 21.907V14.9203C28.6668 14.187 28.0668 13.587 27.3335 13.587ZM15.3335 23.667H10.0002C9.4535 23.667 9.00016 23.2137 9.00016 22.667C9.00016 22.1203 9.4535 21.667 10.0002 21.667H15.3335C15.8802 21.667 16.3335 22.1203 16.3335 22.667C16.3335 23.2137 15.8802 23.667 15.3335 23.667ZM18.0002 18.3337H10.0002C9.4535 18.3337 9.00016 17.8803 9.00016 17.3337C9.00016 16.787 9.4535 16.3337 10.0002 16.3337H18.0002C18.5468 16.3337 19.0002 16.787 19.0002 17.3337C19.0002 17.8803 18.5468 18.3337 18.0002 18.3337Z"
                fill="rgb(var(--locumate-secondary-color))"
              />
            </svg>
          </div>

          <div class="upload-text document-title">
            {{ user.cv.name }}
            <span class="document-info">
              File size {{ user.cv.size }}MB | {{ user.cv.createdAt }}
            </span>
          </div>

          <div class="download-document" @click="openPdf(user.cv)">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 2V9L14 7"
                stroke="black"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12 9L10 7"
                stroke="black"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1.97998 13H6.38998C6.76998 13 7.10998 13.21 7.27998 13.55L8.44998 15.89C8.78998 16.57 9.47998 17 10.24 17H13.77C14.53 17 15.22 16.57 15.56 15.89L16.73 13.55C16.9 13.21 17.25 13 17.62 13H21.98"
                stroke="black"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7 4.12988C3.46 4.64988 2 6.72988 2 10.9999V14.9999C2 19.9999 4 21.9999 9 21.9999H15C20 21.9999 22 19.9999 22 14.9999V10.9999C22 6.72988 20.54 4.64988 17 4.12988"
                stroke="black"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>

    <div class="separator" v-if="user.skills.length"></div>

    <div class="preview-section" v-if="user.skills.length">
      <div class="preview-section__header">
        <div class="preview-section__title">Skills</div>
      </div>

      <div class="preview-section__body">
        <div class="skill-list-pills">
          <el-tag
            v-for="skill in user.skills"
            :key="skill.id"
            class="inverted pill"
            >{{ skill.name }}</el-tag
          >
        </div>
      </div>
    </div>
    <div class="separator" v-if="user.role && user.role.length"></div>

    <div class="preview-section" v-if="user.role && user.role.length">
      <div class="preview-section__header">
        <div class="preview-section__title">Roles</div>
      </div>

      <div class="preview-section__body">
        <div class="skill-list-pills">
          <el-tag v-for="role in user.role" class="inverted pill" :key="role">
            {{ role === "Other" ? `${role}: ${user.otherRole}` : role }}</el-tag
          >
        </div>
      </div>
    </div>
    <div class="separator"></div>

    <div class="preview-section">
      <div class="preview-section__header">
        <div class="preview-section__title">About Me</div>
      </div>

      <div class="preview-section__body">
        <p class="description">
          {{ user.aboutMe }}
        </p>
      </div>
    </div>

    <!-- <div class="info_wrapper user_main_info">
        <div class="image_text_comp">
          <div class="text_wrapper">
            <div class="main_text">{{ user.applicantName }}</div>
          </div>
        </div>
      </div> -->

    <!-- <div class="applicant-info-more mt-2 mb-3">
        <ul>
          <li>{{ user.address }}</li>
          <li v-for="role in user.role" :key="role">{{ role }}</li>
          <li>Duration: {{ user.experience }}</li>
          <li>Hourly Rate: {{ user.hourlyRate }} Hourly</li>
          <li>Annually Rate: {{ user.annuallyRate }} Annually</li>
        </ul>
      </div> -->
    <!-- <div v-if="user.cv.url" class="thumbnail_img el-upload-list--picture-card" @click="openPdf(user.cv)">
        <div v-if="user.cv.fileExtension == 'pdf'">
          <img src="@/assets/img/default_pdf.svg" alt="" class="header_logo_text" />
        </div>

        <div class="upload-text document-title" style="margin-top: 6px;">
          {{ user.cv.name }}
        </div>
      </div> -->

    <div class="el-dialog__footer">
      <div class="button-group">
        <el-button @click="openTriageDrawer()">
          {{ message.Categorize }}
        </el-button>
        <el-button
          @click="awardApplicant()"
          v-if="selectedCategory || selectedCategoryFromParent"
        >
          Notify Applicant
        </el-button>
      </div>
      <el-button
        class="submit_page"
        v-if="user.role == 'pharmacy'"
        type="black"
        @click="goToMap()"
      >
        <span class="locumate_icons locumate_icon-map"></span><span>Map</span>
      </el-button>
      <!-- <el-button class="submit_page" type="blue" @click="goToChat()">
        <span class="locumate_icons locumate_icon-message"></span><span>Chat</span>
      </el-button> -->
    </div>
  </el-drawer>
  <el-drawer
    custom-class="bottom_drop_up"
    v-model="bottomDropUp"
    :append-to-body="true"
    :with-header="false"
    :direction="'btt'"
    :destroy-on-close="true"
  >
    <el-button type="transparent" class="menu_item" @click="sendReport(user)">
      <span class="locumate_icons locumate_icon-flag"></span>
      <span>Report this applicant</span>
    </el-button>
  </el-drawer>

  <el-drawer
    custom-class="bottom_drop_up select-options-applicant"
    v-model="bottomDropUpCategorize"
    :append-to-body="true"
    :with-header="true"
    :direction="'btt'"
    :destroy-on-close="true"
    :show-close="true"
  >
    <div class="category-select-radio-group">
      <!-- <div class="label-text">Select</div> -->
      <div class="auth-header">
        <div class="auth-heading">
          <h1>Select option</h1>
        </div>
      </div>
      <!-- <button class="icon-button close-button" >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM15.36 14.3C15.65 14.59 15.65 15.07 15.36 15.36C15.21 15.51 15.02 15.58 14.83 15.58C14.64 15.58 14.45 15.51 14.3 15.36L12 13.06L9.7 15.36C9.55 15.51 9.36 15.58 9.17 15.58C8.98 15.58 8.79 15.51 8.64 15.36C8.35 15.07 8.35 14.59 8.64 14.3L10.94 12L8.64 9.7C8.35 9.41 8.35 8.93 8.64 8.64C8.93 8.35 9.41 8.35 9.7 8.64L12 10.94L14.3 8.64C14.59 8.35 15.07 8.35 15.36 8.64C15.65 8.93 15.65 9.41 15.36 9.7L13.06 12L15.36 14.3Z"
            fill="black" />
        </svg>
      </button> -->
      <el-radio-group v-model="selectedCategory" @change="handleRadioChange">
        <el-radio
          :label="category.jobApplicantCategory"
          v-for="category in applicantCategories"
          :key="category.id"
          >{{ category.jobApplicantCategory }}</el-radio
        >
      </el-radio-group>
    </div>
  </el-drawer>
</template>

<script>
import {
  ref,
  // reactive,
  onMounted,
  inject,
  computed,
  nextTick,

  // nextTick
} from "vue";
import { useStore } from "vuex";
import { ElMessageBox, ElMessage } from "@/components/Vendor/Element";
import {  isUSRegion } from '@/helpers/region/regionHelper.js';

//   import store from "@/store/store";
import { useRouter } from "vue-router";

export default {
  components: {},
  props: {
    modalName: {
      type: String,
    },
    options: {
      type: Object,
    },
    selectedCategoryFromParent: {
      type: String,
    },
  },
  setup(props, { emit }) {
    console.log("🚀 ~ file: Agency.vue:127 ~ setup ~ props:", props);
    const $store = useStore();
    const $mitt = inject("$mitt");
    const $router = useRouter();
    const bottomDropUpCategorize = ref(false);
    const applicantCategories = inject("applicantCategories");
    // const instance = getCurrentInstance();
    // const pusher = inject(['pusher']);
    //   const $modals = inject("$modals");
    // const loading = ref(true);
    const isUS = isUSRegion();

    const modelMainVisible = ref(false);
    const selectedCategory = ref(null);
    const refreshApplicants = inject("refreshApplicants");
    const userData = $store.getters.GET_USER_DATA;
    const userRole = userData.role;
    const user = computed(() => {
      return props.options.user;
    });
    const message = inject("messages");
    const bottomDropUp = ref(false);
    $mitt.on(props.modalName, (options) => {
      modelMainVisible.value = options.show;
    });

    const openPdf = (file) => {
      window.open(file.url, "_blank");
    };

    const sendReport = (user) => {
      bottomDropUp.value = false;
      $store.dispatch("setReportData", {
        userData: user,
      });
      $router.push({
        name: "report",
        params: {
          userId: user.id,
        },
      });
    };

    const goToChat = () => {
      closeModal();
      const chatId =
        userRole == "pharmacy"
          ? userData.id + "." + user.value.id
          : user.value.id + "." + userData.id;
      // pusher.pusherChatSubscribe(chatId)
      $router.push({
        name: "chat_message",
        params: {
          chatId: chatId,
          // opponentId: user.value.id
        },
      });
    };

    const goToMap = () => {
      closeModal();

      // ${encodeURI('https://www.google.com/maps/dir/?api=1&origin=Space+Needle+Seattle+WA&destination=Pike+Place+Market+Seattle+WA&travelmode=transit')}
      // https://www.google.com/maps/search/?api=1&query=
      // window.open(`https://www.google.com/maps/place/${user.value.address.lat},${user.value.address.lng}`)

      if (
        navigator.platform.indexOf("iPhone") != -1 ||
        navigator.platform.indexOf("iPod") != -1 ||
        navigator.platform.indexOf("MacIntel") != -1 ||
        navigator.platform.indexOf("iPad") != -1
      ) {
        const originCord = userData.address.lat + "," + userData.address.lng;

        const destinationCord =
          user.value.address.lat + "," + user.value.address.lng;

        const origin = userData.address ? `saddr=${originCord}&` : "";

        const destination = user.value.address
          ? `daddr=${destinationCord}&`
          : "";

        window.open(
          `http://maps.apple.com/?${origin}${destination}dirflg=d&t=m`
        );
      }

      // window.open(`maps://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic${origin}${destination}${zoom}`);
      // window.open(`http://maps.apple.com/?saddr=${userData.address.text}&daddr=${user.value.address.text}&dirflg=d&t=m`);
      else {
        const zoom = `&zoom=16`;
        const origin = userData.address.lat
          ? `&origin=${userData.address.lat},${userData.address.lng}`
          : "";
        const destination = user.value.address.lat
          ? `&destination=${user.value.address.lat},${user.value.address.lng}`
          : "";
        window.open(
          `https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic${origin}${destination}${zoom}`
        );
      }
    };
    onMounted(() => {
      console.log("hhhhh");
    });

    const carouselHeight = ref(null);

    const setCarouselHeight = () => {
      setTimeout(() => {
        nextTick(console.log($(".el-carousel").width()));
        $(".el-carousel").css(
          "--carousel-height",
          `${$(".el-dialog__body").width()}px`
        );
      }, 500);

      // $('.el-carousel').css('--carousel-height', `${$('.el-carousel')[0].innerWidth}px`);
    };

    const videoPlayer = ref([]);

    let videosSrc = [];

    const openModal = () => {
      window.addEventListener("resize", setCarouselHeight);
      setCarouselHeight();
    };
    const closeModal = () => {
      modelMainVisible.value = false;
    };

    const openTriageDrawer = () => {
      // selectedApplicant.value = application;
      bottomDropUpCategorize.value = true;
    };

    const handleRadioChange = async (selectedStatus) => {
      await ElMessageBox.confirm(
        `Are you sure you want update the status of the applicant?`,
        "Update status",
        {
          confirmButtonText: "Update",
          cancelButtonText: "Cancel",
          confirmButtonClass: "el-button--primary",
          cancelButtonClass: "secondary",
          showClose: false,
        }
      );

      await (async () => {
        try {
          const applicantStatusCategoriesResponse = await $store.dispatch(
            "UPDATE_JOB_APPLICANT_STATUS_CATEGORY",
            {
              applicationId: user.value.id,
              payload: {
                status: selectedStatus,
              },
            }
          );

          console.log(applicantStatusCategoriesResponse);

          if (applicantStatusCategoriesResponse.data.success) {
            ElMessage({
              type: "success",
              message: applicantStatusCategoriesResponse.data.message,
            });
            closeModal();
            refreshApplicants();
          } else {
            ElMessage({
              type: "info",
              message: applicantStatusCategoriesResponse.data.message,
            });
          }

          bottomDropUpCategorize.value = false;
        } catch (error) {
          ElMessage({
            type: "error",
            message: error.status[0],
          });
          console.log("hellooo");
        }
      })();
    };

    const awardApplicant = async () => {
      try {
        await ElMessageBox.confirm(
          `Are you sure you want to notify this job to ${user.value.applicantName}?`,
          "Notify Applicant",
          {
            confirmButtonText: "Notify",
            cancelButtonText: "Cancel",
            confirmButtonClass: "el-button--primary",
            cancelButtonClass: "secondary",
            showClose: false,
          }
        );

        await (async () => {
          try {
            const response = await $store.dispatch("BULK_NOTIFY_SEEKER", {
              applicationIds: [user.value.id],
            });

            if (response.success) {
              ElMessage({
                type: "success",
                message: response.message,
              });
              closeModal();
              // refreshApplicants();
              emit("refresh-applicants-list");
            } else {
              ElMessage({
                type: "info",
                message: response.message,
              });
            }

            // currentRouteName.value = $router.currentRoute.value.name;
            // console.log("🚀 ~ await ~ currentRouteName.value:", currentRouteName.value)
            // $store.dispatch('PREVIOUS_ROUTE_NAME', currentRouteName.value);

            // $router.push({
            //   name: "job_poster",
            // });
          } catch (error) {
            ElMessage({
              type: "error",
              message: error.message,
            });
          }
        })();
      } catch (error) {
        console.log(error);
      }
    };

    return {
      openModal,
      closeModal,
      // loading,
      modelMainVisible,
      user,
      userRole,
      carouselHeight,
      videoPlayer,
      videosSrc,
      sendReport,
      bottomDropUp,
      goToChat,
      goToMap,
      openPdf,
      selectedCategory,
      handleRadioChange,
      applicantCategories,
      openTriageDrawer,
      bottomDropUpCategorize,
      awardApplicant,
      message,
      isUS
    };
  },
};
</script>
